import { FC, ReactNode } from 'react'
import { useCategories, useTags } from '@/hooks'
import { CategoryState, ComponentState, SideoverState, TagState } from '@/states'
import { Select } from '@/ui/views'
import { GridSearch } from '@/ui/components'
import { XMarkIcon } from '@heroicons/react/16/solid'
import { COMPONENT_DEFUALT_FILTERS } from '@/data'

const GridHeader: FC = (): ReactNode => {
    useCategories()
    useTags()

    const { Categories, Loading: CategoriesLoading } = CategoryState()
    const { Tags, Loading: TagsLoading } = TagState()
    const { Loading: SideoverLoading } = SideoverState()
    const { Filters, Loading, SetState: ComponentSetState } = ComponentState()

    const HandleChange = (value: string, target: keyof ComponentFilterClientTypes) => {
        if (!Loading && !SideoverLoading && !CategoriesLoading && !TagsLoading) {
            const filters = structuredClone(Filters)
            filters[target] = value

            ComponentSetState({ Filters: filters })
        }
    }

    const ResetFilters = () => {
        if (!Loading && !SideoverLoading && !CategoriesLoading && !TagsLoading) {
            ComponentSetState({ Filters: COMPONENT_DEFUALT_FILTERS })
        }
    }

    return (
        <div className='w-full px-2 py-2.5'>
            <div className='flex items-start xl:items-center gap-2 xl:gap-0 flex-col xl:flex-row justify-start xl:justify-between border-[#424242] border-b pb-2'>
                <GridSearch />

                <div className='flex gap-2 items-center select-none flex-col md:flex-row w-full md:w-auto'>
                    <div onClick={ResetFilters} className='bg-[#404040] hidden whitespace-nowrap xl:flex px-2 py-1 gap-1 rounded-full w-auto h-auto justify-center items-center hover:opacity-75 transition-all ease-in-out duration-500 cursor-pointer'>
                        <XMarkIcon className='flex-shrink-0 w-3 h-3 text-[#EBEBEB]' />

                        <span className='text-xs text-[#EBEBEB]'>
                            Clear filters
                        </span>
                    </div>

                    <Select
                        target='Price'
                        label=''
                        placeholder='Mix'
                        required={false}
                        value={Filters?.Price}
                        id='price'
                        // @ts-ignore
                        onChange={HandleChange}
                        showError={false}
                        validationFunction={() => { return { error: false, message: '' } }}
                        idAccessor='_id'
                        valueAccessor='Name'
                        disabled={TagsLoading || SideoverLoading || Loading}
                        list={[
                            {
                                _id: 'mix',
                                Name: 'Mix'
                            },
                            {
                                _id: 'free',
                                Name: 'Free'
                            },
                            {
                                _id: 'paid',
                                Name: 'Paid'
                            }
                        ]}
                    />

                    <Select
                        target='Tag'
                        label=''
                        placeholder='Select Tag'
                        required={false}
                        value={Filters?.Tag}
                        id='tag'
                        // @ts-ignore
                        onChange={HandleChange}
                        showError={false}
                        validationFunction={() => { return { error: false, message: '' } }}
                        list={[{ _id: '', Name: 'All Tags' }, ...Tags ]}
                        idAccessor='_id'
                        valueAccessor='Name'
                        disabled={TagsLoading || SideoverLoading || Loading}
                    />

                    <Select
                        target='Category'
                        label=''
                        placeholder='Select Category'
                        required={false}
                        value={Filters?.Category}
                        id='category'
                        // @ts-ignore
                        onChange={HandleChange}
                        showError={false}
                        validationFunction={() => { return { error: false, message: '' } }}
                        list={[{ _id: '', Name: 'All Categories' }, ...Categories ]}
                        idAccessor='_id'
                        valueAccessor='Name'
                        disabled={CategoriesLoading || SideoverLoading || Loading}
                    />

                    <div onClick={ResetFilters} className='bg-[#404040] w-full flex xl:hidden whitespace-nowrap px-2 py-1 gap-1 rounded-full h-auto justify-center items-center hover:opacity-75 transition-all ease-in-out duration-500 cursor-pointer'>
                        <XMarkIcon className='flex-shrink-0 w-3 h-3 text-[#EBEBEB]' />

                        <span className='text-xs text-[#EBEBEB]'>
                            Clear filters
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GridHeader
